import { Guard } from './guard';

Guard.displayName = 'AvatarInitials';

export { Guard as AvatarInitials };
